import { render, staticRenderFns } from "./IcoPaper.vue?vue&type=template&id=89f0dd1c"
import script from "./IcoPaper.vue?vue&type=script&lang=js"
export * from "./IcoPaper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports